/* eslint-disable */
// This file is generated by dev/generateInitialLangFallback.ts. Do not edit it manually.

import type { LangPackStringValue } from '../../api/types';
import type { LangKey } from '../../types/language';

export default {
  "TestServer": "Test server",
  "PageTitleInactive": "[Inactive]",
  "AuthTitle": "LizardTalk",
  "AuthKeepSignedIn": "Keep me signed in",
  "Code": "Code",
  "Next": "Next",
  "WrongNumber": "Wrong number?",
  "SentAppCode": "We've sent the code to the **Telegram** app on your other device.",
  "LoginJustSentSms": "We've sent you a code via SMS. Please enter it above.",
  "LoginHeaderPassword": "Enter Password",
  "LoginEnterPasswordDescription": "You have Two-Step Verification enabled, so your account is protected with an additional password.",
  "StartText": "Please confirm your country code\nand enter your phone number.",
  "LoginPhonePlaceholder": "Your phone number",
  "LoginNext": "Next",
  "LoginQRLogin": "Log in by QR Code",
  "LoginQRTitle": "Log in to LizardTalk by QR Code",
  "LoginQRHelp1": "Open Telegram or LizardTalk on your phone",
  "LoginQRHelp2": "Go to **Settings** > **Devices** > **Add Device**",
  "LoginQRHelp3": "Point your phone at this screen to confirm login",
  "LoginQRCancel": "Log in by phone number",
  "LoginPasskey": "Log in with Passkey",
  "YourName": "Your Name",
  "LoginRegisterDesc": "Enter your name and add a profile photo.",
  "LoginRegisterFirstNamePlaceholder": "First Name",
  "LoginRegisterLastNamePlaceholder": "Last Name",
  "LoginSelectCountryTitle": "Country",
  "CountryNone": "Country not found",
  "PleaseEnterPassword": "Enter your new password",
  "ErrorPhoneNumberInvalid": "Invalid phone number, please try again",
  "ErrorCodeInvalid": "Invalid code, please try again",
  "ErrorIncorrectPassword": "Invalid password, please try again",
  "ErrorPasswordFlood": "Too many attempts, please try again later",
  "ErrorPhoneBanned": "This phone number is banned",
  "ErrorFloodTime": "Too many attempts, please try again in {time}",
  "ErrorUnexpected": "Unexpected error",
  "ErrorUnexpectedMessage": "Unexpected error: {error}"
} as Record<LangKey, LangPackStringValue>;
